import React from 'react';
import { MenuItem, Select, Typography } from '@mui/material';
import { ArrowDown } from '@linetweet/linetweet-ui';
import clsx from 'clsx';

import { ReportChartViewTypeEnum } from '../types';

import styles from './ChartViewSelect.module.scss';

type Props = {
  value: ReportChartViewTypeEnum;
  onChange: (value: ReportChartViewTypeEnum) => void;
};

const viewByChartViewMap: Record<ReportChartViewTypeEnum, string> = {
  [ReportChartViewTypeEnum.WEEK]: 'Weekly',
  [ReportChartViewTypeEnum.MONTH]: 'Monthly',
};

export function ChartViewSelect({ value, onChange }: Props) {
  return (
    <Select
      variant="outlined"
      IconComponent={ArrowDown}
      className={clsx(styles.chartTypeSelect)}
      value={value}
      onChange={(event) => onChange(event.target.value as ReportChartViewTypeEnum)}
      disabled={false}
      displayEmpty
      required={false}
    >
      <MenuItem value={ReportChartViewTypeEnum.WEEK}>
        <Typography className={styles.chartTypeSelectOptionText}>{viewByChartViewMap[ReportChartViewTypeEnum.WEEK]}</Typography>
      </MenuItem>
      <MenuItem value={ReportChartViewTypeEnum.MONTH}>
        <Typography className={styles.chartTypeSelectOptionText}>{viewByChartViewMap[ReportChartViewTypeEnum.MONTH]}</Typography>
      </MenuItem>
    </Select>
  );
}
